<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col class="col-md-12 col-sm-12 col-lg-12">
        <b-card>
          <div slot="header">
            ایجاد
            <strong v-text="$lang.assessment_plan" />
          </div>
          <LoadingSpinner :loading="isLoading" :text="$lang.sending_data" />
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-row>
              <b-col xs="12" md="12">
                <b-form-group
                  :label="$lang.company"
                  label-for="company_selected"
                  :label-cols="this.$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.company"
                    :rules="$v.company_selected.$params"
                  />

                  <selectAsync
                    :options="company_options"
                    v-model="$v.company_selected.$model"
                    :isValid="
                      $v.company_selected.$dirty
                        ? !$v.company_selected.$error
                        : null
                    "
                    id="id"
                    label="caption"
                    :asyncFind="getCompanies"
                    :loading="companyLoading"
                    @input="getTemplate"
                  />

                  <b-form-invalid-feedback id="company_selected-feedback"
                    >{{ $lang.error_required | replace($lang.company) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col xs="12" md="12">
                <b-form-group
                  :label="$lang.template"
                  label-for="template_selected"
                  :label-cols="this.$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.template"
                    :rules="$v.template_selected.$params"
                  />
                  <selectFind
                    :options="template_options"
                    v-model="$v.template_selected.$model"
                    label="text"
                    :isValid="
                      $v.template_selected.$dirty
                        ? !$v.template_selected.$error
                        : null
                    "
                    :loading="templateLoading"
                  />

                  <b-form-invalid-feedback
                    id="template_selected-feedback"
                    :style="{
                      display: $v.template_selected.$error ? 'block' : 'none',
                    }"
                  >
                    {{
                      $lang.error_required | replace($lang.template)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>

            <div slot="footer" class="form-group form-btn">
              <b-button
                type="reset"
                class="mr-2"
                variant="outline-danger"
                @click="handleBack"
              >
                <mdicon name="close" size="20" />
                {{ $lang.cancelButton }}
              </b-button>
              <b-button type="submit" variant="success">
                {{ $lang.submitButton }}
                <mdicon name="check" size="20" />
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";
import { getCompanyCombo } from "@/services";

export default {
  name: "add-assessment-plan",
  components: { LoadingSpinner },
  validations: {
    company_selected: {},
    template_selected: {
      required,
    },
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      company_selected: null,
      company_options: [],
      companyLoading: false,
      template_selected: null,
      template_options: [],
      templateLoading: false,
    };
  },
  methods: {
    pathOr,
    generateApiUrl,
    handleBack() {
      this.$emit("modal-end-up");
    },
    async getCompanies(text) {
      try {
        this.companyLoading = true;
        const response = await getCompanyCombo(text);
        const { options } = response;
        this.company_options = options;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.companyLoading = false;
      }
    },
    async getTemplate(company) {
      try {
        this.templateLoading = true;
        const queryString = {
          "company_code[]": pathOr(null, ["id"], company),
          complete: true,
        };
        const url = generateApiUrl(
          ["kanoon", "template_combo"],
          [],
          queryString
        );
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.template_options = data.map((x) => {
          return {
            value: x.id,
            text: x.caption,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.templateLoading = false;
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.isLoading = true;
        const url = generateApiUrl(["kanoon", "assessment_plan"]);
        const payload = {
          template_id: pathOr(null, ["value"], this.template_selected),
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.$emit("getData");
        this.handleBack();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="css">
.main .container-fluid {
  padding: 0 10px !important;
}
</style>
